// src/index.tsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import './main.css';
import { Main } from './components/Main';
import { AppState } from './AppState';

const appState = new AppState();

function renderApp() {
  // 既存のどれかがあればそれを使う
  let container =
    document.getElementById('content') ||
    document.getElementById('root') ||
    document.getElementById('app');

  // なければ <div id="content"> を body に自前で作る
  if (!container) {
    console.warn(
      'Root element (#content / #root / #app) が無かったので #content を自動生成します。',
    );
    container = document.createElement('div');
    container.id = 'content';
    document.body.appendChild(container);
  }

  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <Main appState={appState} />
    </React.StrictMode>,
  );
}

// HTML のパースが終わってから実行する
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  renderApp();
}
